// import { combineReducers } from 'redux';
import orderReducer from "./order-reducer";
import productReducer from "./product-reducer";
import authReducer from "./auth-reducer";
// import order, * as fromOrderReducer from './order-reducer';
// import { ProductWhereIn } from '../../api';
// import NumberFormat from 'react-number-format';
// import { store } from '../../index';

// const rootReducer = combineReducers({
//     order: orderReducer,
//     products: productReducer
// });

export default {
  order: orderReducer,
  products: productReducer,
  auth: authReducer,
};

// export default rootReducer;

// untuk mengolah data supaya rapih
export const getOrderCount = (state) => {
  return Object.keys(state.order.tables).reduce((sum, tableKey) => {
    // Mengakses orders dari setiap table
    const orders = state.order.tables[tableKey].orders;

    // Menambahkan jumlah setiap order
    return (
      sum +
      orders.reduce(
        (orderSum, order) => orderSum + parseFloat(order.qty || 0),
        0
      )
    );
  }, 0);
};

export const update = (state) => {
  return Object.keys(state.order).reduce(
    (sum, key) => sum + parseFloat(state.order[key] || 0),
    0
  );
};
